import { Outlet, generatePath } from 'react-router-dom';

import { Navigate } from '@sorare/routing';

import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { NBA_SCOUTING_CENTER_STATS } from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { scoutingCenter } from '@sorare/core/src/lib/glossary';

const ScoutingCenterWatchlistsLayout = () => {
  const {
    flags: { useWatchlists = false },
  } = useFeatureFlags();

  if (!useWatchlists)
    return <Navigate to={generatePath(NBA_SCOUTING_CENTER_STATS)} />;
  return (
    <>
      <PageHeader text={scoutingCenter.myWatchlists} disableBackBrowser />
      <Outlet />
    </>
  );
};

export default ScoutingCenterWatchlistsLayout;
